import React from 'react';
import Icon from './Icon';

function Header({ onToggleSidebar, user, onLogout }) {
  const initials = user?.name?.split(' ').map(part => part[0]).slice(0, 2).join('').toUpperCase() || 'A';
  return (
    <header className="site-header">
      <div className="header-left">
        <button className="hamburger" onClick={onToggleSidebar} aria-label="Toggle sidebar"><Icon name="menu" /></button>
        <div className="brand"><img src='/images/logo.png' alt="Hindustan Pencils Admin" /></div>
      </div>
      {/* <div className="header-search">
        <Icon name="search" />
        <input aria-label="Search" placeholder="Search enquiries, locations..." />
      </div> */}
      <div className="header-right">
        <div className="avatar">{initials}</div>
        <div className="user-copy"><strong>{user?.name || 'Admin'}</strong><span>{user?.role || 'Administrator'}</span></div>
        <button className="logout-button" onClick={onLogout}>Logout</button>
      </div>
    </header>
  );
}

export default Header;
